import EditSpecDetailCOMContainer from "./EditSpecDetailCOMContainer";
export default EditSpecDetailCOMContainer;
